import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import {Grid, Icon, Input} from 'semantic-ui-react';
import {noTimeZoneFullISODate, reverseShortDate} from '../../../common/constants/datesFormat';
import {useSelector} from 'react-redux';

const InputDate = ({
  label,
  keyValue,
  value,
  setDate,
  linesCount,
  minDate,
  maxDate,
  updateNextFields,
  canWrite = true,
  action = null,
}) => {
  const freeDates = useSelector((state) => state.priorizationDates.freeDates);
  return (
    <Grid.Row className='priorization-label-row'>
      <Grid.Column className='no-space' verticalAlign={'middle'} textAlign='right' >
        <div basic className='priorization-label-date-left'>{label}</div>
      </Grid.Column>
      <Grid.Column className='no-space'>
        <DatePicker
          onKeyDown={(e) => {
            !canWrite && e.preventDefault();
          }}
          dateFormat={'dd/MM/yyyy'}
          excludeDates={freeDates}
          minDate={minDate && minDate.toDate()}
          maxDate={maxDate && maxDate.toDate()}
          placeholderText="SELECCIONAR..."
          showYearDropdown
          className='priorization-react-datepicker-wrapper'
          selected={value ? moment(value, noTimeZoneFullISODate).toDate() : null}
          onChange={(value) => {
            setDate(keyValue, value ? moment(value).format(noTimeZoneFullISODate) : null);
            value && updateNextFields(keyValue, moment(value).format(reverseShortDate));
          }}
          customInput={
            <Input type="text" icon='calendar' size='mini' />
          }
          locale="es"
        />
      </Grid.Column>
      <Grid.Column className='no-space' verticalAlign={'middle'}>
        <div className='priorization-label-date-right'>
          {linesCount?.partial}/{linesCount?.total} <Icon name="car" size="small" />
          {action}
        </div>
      </Grid.Column>
    </Grid.Row>
  );
};


export default InputDate;
